module.exports = __webpack_public_path__ + "img/serve7.713ad097.png";